import React from "react"
import useToast from "core/hooks/useToast"
import { GetAllProgressMeet } from "domain/useCase/Student/ProgressMeet/GetAllProgressMeet"
import { SaveProgressMeetFeedback } from "domain/useCase/Student/ProgressMeet/SaveProgressMeetFeedback"
import { GetStudentProgressMeetFeedback } from "domain/useCase/Student/ProgressMeet/GetStudentProgressMeetFeedback"
import { GetClassAttendanceStats } from "domain/useCase/Student/ProgressMeet/GetClassAttendanceStats"
import { GetExamStats } from "domain/useCase/Student/ProgressMeet/GetExamStats"
import { GetMentorshipStats } from "domain/useCase/Student/ProgressMeet/GetMentorshipStats"
import { FetchProgressMeetStatus } from "domain/useCase/Student/ProgressMeet/FetchProgressMeetStatus"
import { ProgressMeetRepositoryImpl } from "data/repository/Student/ProgressMeetRepositoryImpl"
import ProgressMeetAPIDataSourceImpl from "data/API/Student/ProgressMeetAPIDataSourceImpl"
import { useAuth } from "core/context/auth"
import { ProgressMeet, ProgressMeetFeedback } from "domain/model/ProgressMeet"
import { CaptureProgressMeetAttendance } from "domain/useCase/Student/ProgressMeet/CaptureProgressMeetAttendance"

import { STR_FAILURE, STR_UNKNOWN_ERROR_OCCURRED } from "core/constants/strings"
export default function ProgressMeetViewModel() {
  const [activeButtonType, setActiveButtonType] = React.useState(0)
  const { toast, changeToastVisibility, changeToastDetails } = useToast()
  const [allProgressMeet, setAllProgressMeet] = React.useState<ProgressMeet[]>([])
  const [upComingSession, setUpComingSession] = React.useState<ProgressMeet[]>([])
  const [pastSession, setPastSession] = React.useState<ProgressMeet[]>([])
  const [studentFeedback, setStudentFeedback] = React.useState<ProgressMeetFeedback | null>(null)
  const [isFeedbackCardOpen, setIsFeedbackCardOpen] = React.useState<string | null>(null)
  const [openFeedbackModal, setOpenFeedbackModal] = React.useState<string | null>(null)
  const [loading, setLoading] = React.useState(false)
  const [highlyActiveStudent, setHighlyActiveStudent] = React.useState<number>(50)
  const [activeStudent, setActiveStudent] = React.useState<number>(20)
  const [passiveActiveStudent, setPassiveActiveStudent] = React.useState<number>(10)
  const [inActiveStudent, setInActiveStudent] = React.useState<number>(10)
  const [toppedStudent, setToppedStudent] = React.useState<number>(50)
  const [passedStudent, setPassedStudent] = React.useState<number>(30)
  const [failedStudent, setFailedStudent] = React.useState<number>(20)
  const [bookedStudent, setBookedStudent] = React.useState<number>(50)
  const [attendedStudent, setAttendedStudent] = React.useState<number>(50)
  const [examTitle, setExamTitle] = React.useState<string>("Exam title here!")
  const [mentorshipTitle, setMentorshipTitle] = React.useState<string>("Mentor session stage")
  const [progressMeetLink, setProgressMeetLink] = React.useState("")
  const [attendanceFailure, setAttendanceFailure] = React.useState(false)
  const [attendanceFailureCount, setAttendanceFailureCount] = React.useState(0)
  const [waitingTime, setWaitingTime] = React.useState(10)
  const [sessionId, setCurrentSessionId] = React.useState("")
  const [currentClassLink, setCurrentClassLink] = React.useState("")
  const [attendanceLoader, setAttendanceLoader] = React.useState(false)
  const [examLoading, setExamLoading] = React.useState(false)
  const [classLoading, setClassLoading] = React.useState(false)
  const [mentorshipLoading, setMentorshipLoading] = React.useState(false)
  const [statusMap, setStatusMap] = React.useState<{ [meetingId: string]: boolean | null }>({})
  const [loadingStatuses, setLoadingStatuses] = React.useState<boolean>(true)

  const { auth } = useAuth()

  const GetMentorshipStatsUseCase = new GetMentorshipStats(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )
  const GetClassAttendanceStatsUseCase = new GetClassAttendanceStats(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )
  const GetExamStatsUseCase = new GetExamStats(new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl()))

  const getAllProgressMeetsUseCase = new GetAllProgressMeet(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )

  const saveProgressMeetFeedbackUseCase = new SaveProgressMeetFeedback(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )

  const captureProgressMeetAtendanceUseCase = new CaptureProgressMeetAttendance(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )

  const getStudentProgressMeetFeedbackUseCase = new GetStudentProgressMeetFeedback(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )
  const fetchProgressMeetStatusUseCase = new FetchProgressMeetStatus(
    new ProgressMeetRepositoryImpl(new ProgressMeetAPIDataSourceImpl())
  )

  function changeActiveButtonType(index: number) {
    if (activeButtonType !== index) setActiveButtonType(index)
  }

  async function getAllProgressMeets() {
    try {
      const progressMeets = await getAllProgressMeetsUseCase.invoke(auth)
      setAllProgressMeet(progressMeets || [])
    } catch (error) {
      console.error("Failed to fetch progress meets:", error)

      setAllProgressMeet([])
    }
  }

  async function getStudentProgressMeetFeedback(meetingId: string) {
    setLoading(true)
    try {
      const progressMeets = await getStudentProgressMeetFeedbackUseCase.invoke(auth, meetingId)
      if (Array.isArray(progressMeets) && progressMeets.length > 0) {
        setStudentFeedback(progressMeets[0])
        setIsFeedbackCardOpen(meetingId)
        setOpenFeedbackModal(null)
      } else {
        setStudentFeedback(null)
        setIsFeedbackCardOpen(null)
        setOpenFeedbackModal(meetingId)
      }
    } catch (error) {
      console.error("Failed to fetch progress meets:", error)
    } finally {
      setLoading(false)
    }
  }

  async function captureProgressMeetAtendance(meetingId: string) {
    const response = await captureProgressMeetAtendanceUseCase.invoke(auth, meetingId)
    // if(response?.data?.)
    if (response?.link) {
      setProgressMeetLink(response?.link)
    }
  }

  async function saveProgressMeetFeedback(feedback: ProgressMeetFeedback) {
    try {
      await saveProgressMeetFeedbackUseCase.invoke(auth, feedback)
    } catch (error) {
      console.error("Failed to save progress meet feedback:", error)
    }
  }

  async function fetchProgressMeetStatus(pastSessions: any) {
    try {
      if (!pastSessions || pastSessions.length === 0) {
        setLoadingStatuses(false)
        return
      }

      setLoadingStatuses(true)

      const statusResults = await Promise.all(
        pastSessions.map(async (session: any) => {
          try {
            const status = await fetchProgressMeetStatusUseCase.invoke(auth, session.meeting_id)

            return { meetingId: session.meeting_id, is_attended: status ?? false }
          } catch (error) {
            console.error(`Failed to fetch status for meeting ${session.meeting_id}:`, error)
            return { meetingId: session.meeting_id, is_attended: null }
          }
        })
      )

      const newStatusMap: { [meetingId: string]: boolean | null } = {}
      statusResults.forEach(({ meetingId, is_attended }) => {
        newStatusMap[meetingId] = is_attended
      })

      setStatusMap(newStatusMap)
    } catch (error) {
      console.error("Failed to fetch all progress meet statuses:", error)
    } finally {
      setLoadingStatuses(false)
    }
  }

  const filterSessions = () => {
    const currentDate = new Date()

    const upcoming: ProgressMeet[] = []
    const past: ProgressMeet[] = []

    allProgressMeet.forEach((meeting) => {
      const sessionDate = new Date(meeting.session_timestamp * 1000)
      const threeHoursAfterSession = new Date(sessionDate.getTime() + 3 * 60 * 60 * 1000)
      if (sessionDate >= currentDate || threeHoursAfterSession > currentDate) {
        upcoming.push(meeting)
      } else {
        past.push(meeting)
      }
    })

    setUpComingSession(upcoming)

    setPastSession(past)
  }

  const getClassAttendanceStats = async (batches: string[], meetingDate: number) => {
    try {
      setClassLoading(true)

      const cacheKey = `attendanceStats_${batches.sort().join(",")}_${meetingDate}`

      const cachedData = localStorage.getItem(cacheKey)
      if (cachedData) {
        const parsedData = JSON.parse(cachedData)
        setHighlyActiveStudent(parsedData.highly_active)
        setPassiveActiveStudent(parsedData.passive_active)
        setActiveStudent(parsedData.active)
        setInActiveStudent(parsedData.inactive)
        setClassLoading(false)
        return
      }

      const response = await GetClassAttendanceStatsUseCase.invoke(auth, batches, meetingDate)

      if (response) {
        localStorage.setItem(cacheKey, JSON.stringify(response))

        setHighlyActiveStudent(response.highly_active)
        setPassiveActiveStudent(response.passive_active)
        setActiveStudent(response.active)
        setInActiveStudent(response.inactive)
      }
    } catch (error) {
      console.error("Error fetching class attendance stats:", error)
    } finally {
      setClassLoading(false)
    }
  }

  const getExamStats = async (batches: string[], meetingDate: number) => {
    try {
      setExamLoading(true)

      const cacheKey = `examStats_${batches.sort().join(",")}_${meetingDate}`
      const cachedData = localStorage.getItem(cacheKey)

      if (cachedData) {
        const parsedData = JSON.parse(cachedData)
        setToppedStudent(parsedData.topped)
        setPassedStudent(parsedData.passed)
        setFailedStudent(parsedData.failed)
        setExamTitle(parsedData.nearestExamTitle)
        setExamLoading(false)
        return
      }

      const response = await GetExamStatsUseCase.invoke(auth, batches, meetingDate)

      if (response) {
        localStorage.setItem(cacheKey, JSON.stringify(response))
        setToppedStudent(response.topped)
        setPassedStudent(response.passed)
        setFailedStudent(response.failed)
        setExamTitle(response.nearestExamTitle)
      }
    } catch (error) {
      console.error("Error fetching exam stats:", error)
    } finally {
      setExamLoading(false)
    }
  }

  const getMentorshipStats = async (batches: string[], meetingDate: number) => {
    try {
      setMentorshipLoading(true)

      const cacheKey = `mentorshipStats_${batches.sort().join(",")}_${meetingDate}`
      const cachedData = localStorage.getItem(cacheKey)

      if (cachedData) {
        const parsedData = JSON.parse(cachedData)
        setAttendedStudent(parsedData.attendancePercentage)
        setBookedStudent(parsedData.bookedPercentage)
        setMentorshipTitle(parsedData.mostRecentSessionName)
        setMentorshipLoading(false)
        return
      }

      const response = await GetMentorshipStatsUseCase.invoke(auth, batches, meetingDate)

      if (response) {
        localStorage.setItem(cacheKey, JSON.stringify(response))
        setAttendedStudent(response.attendancePercentage)
        setBookedStudent(response.bookedPercentage)
        setMentorshipTitle(response.mostRecentSessionName)
      }
    } catch (error) {
      console.error("Error fetching mentorship stats:", error)
    } finally {
      setMentorshipLoading(false)
    }
  }

  const handleJoinNow = async (lecture: any) => {
    setAttendanceFailure(true)
    setWaitingTime(10)

    setCurrentSessionId(lecture)
    setAttendanceLoader(true)
    const session_id = lecture?.meeting_id
    setCurrentClassLink(lecture?.class_link)

    if (!session_id) {
      changeToastDetails(STR_FAILURE, STR_UNKNOWN_ERROR_OCCURRED)
      changeToastVisibility(true)
      return
    }

    const response = await captureProgressMeetAtendanceUseCase.invoke(auth, session_id)

    if (!response) {
      // ✅ Use functional updater to ensure latest state

      setWaitingTime(10)

      // ✅ Use functional updater to ensure latest state
      setAttendanceFailureCount((prevCount) => {
        const newCount = prevCount + 1
        localStorage.setItem("attendanceFailureCount", newCount.toString()) // Keep localStorage in sync
        return newCount
      })
    } else {
      window.open(response?.link)
      setAttendanceFailure(false)
      setAttendanceFailureCount(0) // Reset failure count on success
      localStorage.setItem("attendanceFailureCount", "0")
    }
  }
  return {
    toast,
    activeButtonType,
    setActiveButtonType,
    changeActiveButtonType,
    changeToastVisibility,
    getAllProgressMeets,
    allProgressMeet,
    setAllProgressMeet,
    filterSessions,
    upComingSession,
    pastSession,
    saveProgressMeetFeedback,
    getStudentProgressMeetFeedback,
    studentFeedback,
    isFeedbackCardOpen,
    setIsFeedbackCardOpen,
    openFeedbackModal,
    setOpenFeedbackModal,
    highlyActiveStudent,
    activeStudent,
    inActiveStudent,
    passiveActiveStudent,
    toppedStudent,
    failedStudent,
    passedStudent,
    bookedStudent,
    attendedStudent,
    examTitle,
    mentorshipTitle,

    mentorshipLoading,
    classLoading,
    examLoading,
    setHighlyActiveStudent,
    setActiveStudent,
    setPassiveActiveStudent,
    setInActiveStudent,
    setBookedStudent,
    setAttendedStudent,
    setToppedStudent,
    setPassedStudent,
    setFailedStudent,
    captureProgressMeetAtendance,
    progressMeetLink,
    waitingTime,
    attendanceFailure,
    setAttendanceFailure,
    currentClassLink,
    handleJoinNow,
    getMentorshipStats,
    getClassAttendanceStats,
    getExamStats,
    attendanceFailureCount,
    setWaitingTime,
    statusMap,
    loadingStatuses,
    fetchProgressMeetStatus,
  }
}
